import { render, staticRenderFns } from "./PADailyTransaction.vue?vue&type=template&id=505480e0&"
import script from "./PADailyTransaction.vue?vue&type=script&lang=js&"
export * from "./PADailyTransaction.vue?vue&type=script&lang=js&"
import style0 from "./PADailyTransaction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PADailyTransaction.vue"
export default component.exports